import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { DashboardAlertApi, ApiDashboardAlertSetting } from '../axios/generated/settingManage';
import { IError } from '../interfaces/IError';
import { ISettingRepository } from '../interfaces/ISettingRepository';
import { customAxiosInstance } from '../axios/axiosInstance';
import { axiosErrorHandler } from '../axios/axiosError';

/**
 * 設定を永続化するリポジトリ
 */
export class SettingRepository implements ISettingRepository {
  /**
   * ダッシュボードアラート設定を取得する
   */
  async getDashboardAlertSetting(): Promise<INetworkResult<ApiDashboardAlertSetting, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const dashboardAlertApi = new DashboardAlertApi(undefined, undefined, axiosInstance);
    // APIを叩く
    try {
      const apiResponse = await dashboardAlertApi.get();
      switch (apiResponse.status) {
        case 200:
          const result: ApiDashboardAlertSetting = apiResponse.data.result;
          return { status: { type: 'success', data: result } };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (e) {
      return { status: { type: 'error', error: axiosErrorHandler(e) } };
    }
  }

  /**
   * ダッシュボードアラート設定を保存する
   * @param request - リクエスト
   */
  async putDashboardAlertSetting(request: ApiDashboardAlertSetting): Promise<INetworkResult<void, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const dashboardAlertApi = new DashboardAlertApi(undefined, undefined, axiosInstance);
    // APIを叩く
    try {
      const apiResponse = await dashboardAlertApi.put(request);
      switch (apiResponse.status) {
        case 200:
          return { status: { type: 'success', data: undefined } };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (e) {
      return { status: { type: 'error', error: axiosErrorHandler(e) } };
    }
  }
}
